/* BMPP launch countdown + email capture.
   - Countdown: ticks DD:HH:MM:SS to data-target (ISO-8601 w/ tz offset), swaps to the
     "It's Live" state when the target passes.
   - Capture: AJAX-submits the native Shopify customer form so there's NO page reload.
     A reload sets ?customer_posted=true (global to ALL customer forms on the page), so the
     footer newsletter form renders "success" and the theme's newsletter-form.js scroll-focuses
     it -> the page kicks to the footer. Inline success/error instead.
   - The submit is intercepted via a SINGLE document-level, CAPTURE-PHASE listener scoped to
     .countdown-launch__form, so it fires regardless of bind timing / section re-renders and
     before the browser default + the theme's own form scripts. (A per-form listener proved
     unreliable on this theme — 3 customer forms + global handlers.)
   Re-binds countdown on shopify:section:load so it also works inside the theme editor. */
(function () {
  // Fallback for the no-JS / native path: a reload with ?customer_posted=true would scroll to
  // the footer form. Strip the param ASAP (this script is in the hero, runs before the footer
  // script) and surface inline success at the hero instead.
  var nativePosted = false;
  try {
    if (window.location.search.indexOf("customer_posted=true") !== -1) {
      nativePosted = true;
      if (window.history && history.replaceState) history.replaceState(null, "", window.location.pathname);
    }
  } catch (e) {}

  function pad(n) { return n < 10 ? "0" + n : "" + n; }

  function initCountdown(el) {
    if (el.__cdInit) return;
    el.__cdInit = true;

    var target = new Date(el.getAttribute("data-target")).getTime();
    if (isNaN(target)) { el.classList.add("is-ready"); return; }

    var daysEl = el.querySelector("[data-cd-days]");
    var hoursEl = el.querySelector("[data-cd-hours]");
    var minsEl = el.querySelector("[data-cd-mins]");
    var secsEl = el.querySelector("[data-cd-secs]");
    var innerEl = el.querySelector("[data-cd-inner]");
    var liveEl = el.querySelector("[data-cd-live]");
    var timer = null;

    function goLive() {
      if (timer) { clearInterval(timer); timer = null; }
      el.classList.add("is-live");
      if (innerEl) innerEl.hidden = true;
      if (liveEl) liveEl.hidden = false;
    }

    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) { goLive(); return; }
      var s = Math.floor(diff / 1000);
      var d = Math.floor(s / 86400); s -= d * 86400;
      var h = Math.floor(s / 3600); s -= h * 3600;
      var m = Math.floor(s / 60); s -= m * 60;
      if (daysEl) daysEl.textContent = pad(d);
      if (hoursEl) hoursEl.textContent = pad(h);
      if (minsEl) minsEl.textContent = pad(m);
      if (secsEl) secsEl.textContent = pad(s);
    }

    tick();
    el.classList.add("is-ready");
    if (!el.classList.contains("is-live")) { timer = setInterval(tick, 1000); }
  }

  function captureOf(form) {
    if (form.closest) return form.closest("[data-cd-capture]");
    var n = form.parentNode;
    while (n && n.getAttribute && !n.hasAttribute("data-cd-capture")) { n = n.parentNode; }
    return (n && n.getAttribute) ? n : null;
  }
  function showFormError(capture, msg) {
    var status = capture && capture.querySelector("[data-cd-status]");
    if (status) { status.textContent = msg || "Something went wrong — please try again."; status.hidden = false; }
  }
  function showFormSuccess(capture) {
    if (!capture) return;
    var msg = capture.getAttribute("data-success") || "You're on the list.";
    capture.innerHTML = '<p class="countdown-launch__success"></p>';
    capture.firstChild.textContent = msg;
  }

  // Single, document-level, capture-phase interceptor for the hero email form. Capture phase
  // + document scope = catches the submit before the browser default and before any theme
  // handler, so the page never reloads and never jumps to the footer.
  function onSubmit(e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains("countdown-launch__form")) return;
    e.preventDefault();
    var capture = captureOf(form);
    var status = capture && capture.querySelector("[data-cd-status]");
    if (status) { status.hidden = true; status.textContent = ""; }
    if (!form.checkValidity()) { form.reportValidity(); return; }
    var email = form.querySelector('input[type="email"]');
    var btn = form.querySelector('button[type="submit"]');
    if (btn) btn.disabled = true;
    fetch(form.action, { method: "POST", body: new FormData(form), headers: { "Accept": "text/html" } })
      .then(function (res) {
        if (res.url && res.url.indexOf("customer_posted=true") !== -1) {
          showFormSuccess(capture);
        } else {
          if (btn) btn.disabled = false;
          showFormError(capture, email && email.value ? "That didn’t go through — check the address and try again." : null);
        }
      })
      .catch(function () { if (btn) btn.disabled = false; showFormError(capture); });
  }
  document.addEventListener("submit", onSubmit, true);

  function initScope(scope) {
    var nodes = (scope || document).querySelectorAll("[data-countdown]");
    for (var i = 0; i < nodes.length; i++) {
      initCountdown(nodes[i]);
      if (nativePosted) {
        var capture = nodes[i].querySelector("[data-cd-capture]");
        if (capture) showFormSuccess(capture);
      }
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initScope(document); });
  } else {
    initScope(document);
  }

  // Theme editor re-renders sections — re-init countdown within the reloaded section.
  document.addEventListener("shopify:section:load", function (e) { initScope(e.target); });
})();
